import React, { memo } from 'react';
export var BlockMonogramPiece2 = /*#__PURE__*/memo(function (_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#003B5C' : _ref$color,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 134 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 600 : _ref$width;
  return /*#__PURE__*/React.createElement("svg", {
    width: width,
    height: height,
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 232.2 51.9",
    style: {
      enableBackground: 'new 0 0 232.2 51.9'
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("polyline", {
    fill: color,
    points: "33.1,0.3 33.1,51.9 93.5,0.3 "
  }));
});